import * as React from "react";
import { cn } from "@/lib/utils";

interface SectionCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  testId?: string;
}

export function SectionCard({
  title,
  description,
  children,
  actions,
  className,
  testId,
}: SectionCardProps) {
  return (
    <section
      className={cn(
        "rounded-2xl bg-white border border-slate-200 shadow-sm p-4 md:p-5 flex flex-col gap-3",
        className
      )}
      data-testid={testId}
    >
      <header className="flex items-center justify-between gap-3">
        <div className="space-y-1">
          <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
          {description && (
            <p className="text-xs text-slate-500">{description}</p>
          )}
        </div>
        {actions}
      </header>
      <div>{children}</div>
    </section>
  );
}
